var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"appbar-realtime-clock",on:{"click":function($event){return _vm.sayCurrentTime()}}},[_vm._v(_vm._s(_vm.getCurrentTimeObj.twelveHourTimeWithSeconds)),_c('br',{}),_vm._v(_vm._s(_vm.$datedJS.dated.getDateShort()))])}
var staticRenderFns = []

export { render, staticRenderFns }